<template>
    <span>
        <span v-if="value" :class="mainClass">{{value}}</span>
        <span v-if="!value && this.$slots.default &&  this.$slots.default[0].text.length" :class="mainClass">
            <slot></slot>
        </span>
    </span>
</template>

<script>
export default {
    data() {
        return {

        }
    },

    props: {
        value: String,
        white: Boolean,
        red: Boolean,
        purple: Boolean,
        orange: Boolean,
        transparent: Boolean,
        primary: Boolean,
        success: Boolean,
        error: Boolean,
        small: Boolean,
        darkred: Boolean,
    },

    computed: {
        mainClass() {
            let newClass = ''
            if(!this.transparent)
                newClass = "flag"
            if(this.purple)
                newClass += " flag-purple"
            else if(this.orange)
                newClass += " flag-orange"
            else if(this.darkred)
                newClass += " flag-dark-red"
            else if(this.red) //to remove
                newClass += " flag-error"
            else if(this.error)
                newClass += " flag-error"
            else if(this.primary)
                newClass += " flag-primary"
            else if(this.success)
                newClass += " flag-success"
            else if(this.white)
                newClass += " flag-white"


            if(this.small)
                newClass += " flag-small"

            return newClass
        },
        visible() {
            return true
            if(!this.$slots.default)
                return false
            else
                return !!this.$slots.default[0].text.length
        }
    },

    methods: {

    }
}
</script>

<style scoped>
        .flag {
            background-color: rgba(0,0,0,0.1);
            color:rgba(0,0,0,0.5);
            font-size: 12px;
            font-weight: normal;
            padding: 2px 4px 2px 4px;
            border-radius: 3px;
            border: solid 1px rgba(0,0,0,0.2);
            margin-top: -5px;
            max-width: 150px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        .flag-small {
            font-size:8px;
        }

        .flag-error {
            color: red;
            background-color:rgb(255, 188, 188);
            border-color:red;
        }

        .flag-dark-red {
            color: rgb(80, 22, 22);
            background-color:rgb(240, 138, 138);
            border-color:rgb(85, 30, 30);
        }



        .flag-primary {
            color: rgb(1, 101, 194);
            background-color: rgba(4, 153, 253, 0.315);
            border-color: rgba(1, 101, 194, 0.77);
        }

        .flag-success {
            color: rgba(1, 128, 39, 0.77);
            background-color: rgba(28, 210, 52, 0.2);
            border-color: rgba(1, 128, 39, 0.77);
        }

        .flag-purple {
            color: rgba(22, 8, 150, 0.77);
            background-color: rgba(28, 31, 210, 0.2);
            border-color: rgba(20, 1, 128, 0.77);
        }

        .flag-orange {
            color: rgba(252, 123, 2, 1);
            background-color: rgba(247, 172, 129, 0.384);
            border-color: rgba(252, 123, 2, 1);
        }

        .flag-white {
            color: #aaa;
            background-color: white;
            border-color: #aaa;
        }
</style>




// WEBPACK FOOTER //
// Flag.vue?e6b030a8